var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex justify-content-center", style: { gap: "12px" } },
      [
        _c(
          "div",
          { staticClass: "d-flex align-items-center", style: { gap: "20px" } },
          [
            _c(
              "div",
              [
                _c("el-progress", {
                  attrs: {
                    width: 80,
                    type: "dashboard",
                    percentage: _vm.percentage,
                    color: _vm.colors
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("el-input-number", {
              attrs: { placeholder: "Ex: 15", min: 0, max: 100, size: "mini" },
              model: {
                value: _vm.internalValue,
                callback: function($$v) {
                  _vm.internalValue = $$v
                },
                expression: "internalValue"
              }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77f510db", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77f510db","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_micro/Form/FormProgressBarMoon.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-77f510db","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_micro/Form/FormProgressBarMoon.vue
// module chunks = 2